import React from 'react';

export default function CopyrightWidget({ ...restProps }) {
  return <p {...restProps}>© Nathaniel J. Liberty 2019</p>;
}
